function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Star Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.001,2.12962247 L6.97635322,6.23131288 C6.90351389,6.37887658 6.7627286,6.48115082 6.59987589,6.50480689 L2.07452535,7.16216153 L5.35000534,10.3549563 C5.46785934,10.4698353 5.5216322,10.6353543 5.49379707,10.7975639 L4.72016918,15.3059954 L8.76831123,13.1774439 C8.91398297,13.100852 9.08801703,13.100852 9.23368877,13.1774439 L13.2820301,15.3059954 L12.509188,10.7974769 C12.4813868,10.6352932 12.535163,10.4698135 12.6529947,10.3549563 L15.9284511,7.16218446 L11.4021368,6.50480874 C11.239279,6.48115621 11.0984881,6.37888066 11.0256468,6.23131288 L9.001,2.12962247 Z M6.19599503,5.55297959 L8.55264678,0.778687123 C8.73606481,0.407104292 9.26593519,0.407104292 9.44935322,0.778687123 L11.8060013,5.55297223 L17.0748632,6.31819126 C17.4849946,6.37775639 17.6487765,6.88176408 17.3520053,7.17104368 L13.5392192,10.887581 L14.438812,16.1355231 C14.5088274,16.5439709 14.0801065,16.8554111 13.7133112,16.6625561 L9.001,14.1849001 L4.28868877,16.6625561 C3.92185744,16.85543 3.4931086,16.5439118 3.56320293,16.1354361 L4.46374047,10.8875417 L0.650994665,7.17104368 C0.354227727,6.88176823 0.518000054,6.37776793 0.928124108,6.31819311 L6.19599503,5.55297959 Z",
  id: "star-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "star-Icon/Global/Star-outline",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "star-Swatches/DarkGreen",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "star-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#star-path-1"
})));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.4b67c52a.svg";
export { ForwardRef as ReactComponent };